import moment from "moment";
import momentjalaali from "moment-jalaali";
export const ConvertToPersian = function (gregorianDate) {
    if (moment(gregorianDate).isValid())
        return momentjalaali(gregorianDate).format("jYYYY/jMM/jDD");

    throw "date is invalid"
}

export const ConvertToGregorian = function (shamsiDate) {
    if (momentjalaali(shamsiDate, 'jYYYY/jMM/jDD').isValid())
        return momentjalaali(shamsiDate, "jYYYY/jMM/jDD").format("YYYY/MM/DD");

    throw "date is invalid";
}
export const ConvertToGregorianDashFormat = function (shamsiDate) {
    if (momentjalaali(shamsiDate, 'jYYYY/jMM/jDD').isValid())
        return momentjalaali(shamsiDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

    throw "date is invalid";
}

export const AddPersian = function (shamsiDate, element, value) {
    // element :day , month , year
    var el = "unknown"
    switch (element) {
        case 'day':
            el = 'day'
            break;
        case 'month':
            el = 'jMonth'
            break;
        case 'year':
            el = 'jYear'
            break;
        default:
            break;
    }
    if (momentjalaali(shamsiDate, 'jYYYY/jMM/jDD').isValid()) {
        var date = momentjalaali(shamsiDate, "jYYYY/jMM/jDD");
        return date.add(value, el).format("jYYYY/jMM/jDD");
    }


    throw "date is invalid";
}


export default {
    ConvertToPersian,
    ConvertToGregorian,
    AddPersian,
    ConvertToGregorianDashFormat
}